import { Box, IconButton, Typography, Stack, Container } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Link } from 'react-router-dom';


const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                width: "100%",
                backgroundColor: "#000000ff",
                color: "#fff",
                py: 3,
                borderTop: "1px solid rgba(255,255,255,0.1)",
            }}
        >
            <Container
                maxWidth="lg"
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: { xs: "center", sm: "left" },
                }}
            >
                {/* Brand Logo */}
                <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", letterSpacing: 1, mb: { xs: 2, sm: 0 } }}
                >
                    QuantikFlow
                </Typography>

                {/* Contact Info */}
                <Stack
                    direction="column"
                    spacing={1}
                    alignItems="center" // totul centrat pe coloană
                >
                    {/* Iconițe */}
                    <Stack direction="row" spacing={2}>
                        <IconButton
                            component="a"
                            href="lermy2013@gmail.com"
                            sx={{ color: "#fff", "&:hover": { color: "#00bcd4" } }}
                        >
                            <EmailIcon />
                        </IconButton>
                        {/* <IconButton
                            component="a"
                            href="https://linkedin.com/in/username"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: "#fff", "&:hover": { color: "#0e76a8" } }}
                        >
                            <LinkedInIcon />
                        </IconButton> */}
                        <IconButton
                            component="a"
                            href="tel:+40 730 580 430"
                            sx={{ color: "#fff", "&:hover": { color: "#4caf50" } }}
                        >
                            <PhoneIcon />
                        </IconButton>
                    </Stack>

                    {/* Numere centrate sub iconițe */}
                    <Stack direction="column" spacing={0.5} alignItems="center">
                        <Typography variant="body2" sx={{ color: "#aaa" }}>
                            +40 749 221 917
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#aaa" }}>
                            +40 730 580 430
                        </Typography>
                    </Stack>
                </Stack>
                <Typography variant="body2" sx={{ color: "#aaa", mt: 2, textAlign: "center", mb: 2 }}>
                    © {new Date().getFullYear()} QuanticFlow. Toate drepturile sunt rezervate.
                </Typography>
                <Typography sx={{ color: "#fff" }}>          <Link to="/">
            <Box
              component="img"
              src="/QuantikFlow-nightMode.png"
              alt="QuantikFlow"
              sx={{
                ml: 2,
                height: 90,
                width: 'auto',
                cursor: 'pointer',
              }}
            />
          </Link></Typography>
            </Container>
        </Box>
    );
};

export default Footer;
